import { create } from 'zustand';
import { DataBasicEncoder } from "../../util/data-basic-encoder";
import { RoleType } from '../../models/db';

export interface Identity {
    username?: string;
    email: string;
    idUser: string;
    role: RoleType | undefined;
    avatar?: string;
    idCompanySelected?: string;
}

interface IdentityStore {
    identity: Identity | null;
    setIdentity: (identity: Identity) => void;
    clearIdentity: () => void;
    loadIdentity: () => void;
}

const identityLocalStorageKey = 'identity';

// Utilidad para verificar si un objeto cumple con la interfaz Identity
const conformsToInterface = <T>(obj: any, reference: T): obj is T => {
    for (const key in reference) {
        // console.log("si", key, obj[key])
        if (!obj.hasOwnProperty(key)) {
            // console.log("no", key)
            return false;
        }
    }
    return true;
};

export const useIdentityStore = create<IdentityStore>((set, get) => ({
    identity: null, // Estado inicial nulo, se carga después desde localStorage

    setIdentity: (identity: Identity) => {
        // Codifica y guarda la identidad en localStorage
        const encodedIdentity = DataBasicEncoder.encode(identity);
        localStorage.setItem(identityLocalStorageKey, encodedIdentity);
        set({ identity });
    },

    clearIdentity: () => {
        // Limpia la identidad de localStorage y del estado
        localStorage.removeItem(identityLocalStorageKey);
        set({ identity: null });
    },

    loadIdentity: () => {
        // Carga la identidad desde localStorage si está disponible
        const storedIdentity = localStorage.getItem(identityLocalStorageKey);
        console.log("🔍 Identity almacenada (raw):", storedIdentity);

        if (storedIdentity) {
            const decodedIdentity = DataBasicEncoder.decode(storedIdentity);
            console.log("🔍 Identity decodificada:", decodedIdentity);

            // Verifica si el objeto decodificado cumple con la interfaz Identity
            const EXPECTED_INTERFACE = {
                avatar: "",
                email: "",
                role: null,
                idUser: "",
            };

            if (conformsToInterface(decodedIdentity, EXPECTED_INTERFACE)) {
                set({ identity: decodedIdentity });
            } else {
                // Registra un error detallado si no cumple con la interfaz
                console.error(`
    ********************************************************
    🚨 ERROR: Objeto de identidad almacenado no cumple con la interfaz esperada.
    --------------------------------------------------------
    ➡ Se esperaba la interfaz:
      ${JSON.stringify(EXPECTED_INTERFACE, null, 2)}
    
    ➡ Objeto recibido:
      ${JSON.stringify(decodedIdentity, null, 2)}
    ********************************************************
    `);
            }
        } else {
            console.warn("⚠️ No se encontró ninguna identidad almacenada en localStorage.");
        }
    }

}));

// En el componente principal o en el punto de entrada de tu aplicación, puedes cargar la identidad:
// useIdentityStore.getState().loadIdentity();
